import {
  Cog,
  Gift,
  LayoutDashboard,
  Siren,
  TrendingUpDown,
  Trophy,
  User,
  Users,
} from "lucide-react";
import { FaStamp } from "react-icons/fa";

export const adminLinks = [
  {
    route: "/app/dashboard",
    name: "Dashboard",
    Icon: LayoutDashboard,
    allowed: ["Default"],
  },
  {
    route: "/app/profile",
    name: "Profile",
    Icon: User,
    allowed: ["Default"],
  },
  {
    route: "/app/bids",
    name: "My Bids",
    Icon: Gift,
    allowed: ["Default"],
  },
  {
    route: "/app/wins",
    name: "My Wins",
    Icon: Trophy,
    allowed: ["Default"],
  },
  {
    route: "/app/claims",
    name: "Claim Requests",
    Icon: Gift,
    allowed: ["Default"],
  },
  {
    route: "/app/users",
    name: "Users",
    Icon: Users,
    allowed: ["admin"],
  },
  {
    route: "/app/claims/approval",
    name: "Claims Approval",
    Icon: Gift,
    allowed: ["admin"],
  },
  {
    route: "/app/settings",
    name: "Settings",
    Icon: Cog,
    allowed: ["admin"],
  },

  {
    route: "/app/reporting",
    name: "Reporting",
    Icon: Siren,
    allowed: ["admin"],
  },
  {
    route: "/app/metrics",
    name: "Metrics",
    Icon: TrendingUpDown,
    allowed: ["admin"],
  },
  {
    route: "/app/witness/sign",
    name: "Witness Requests",
    Icon: Users,
    allowed: ["admin", "Default"],
  },
  {
    route: "/app/approvals",
    name: "Approvals",
    Icon: FaStamp,
    allowed: ["admin", "Default"],
  },
  // {
  //   route: "/app/profile",
  //   name: "Profile",
  //   Icon: User,
  //   allowed: ["Super Admin", "Default"],
  // },
];
export const staffLinks = [
  {
    route: "/app/dashboard",
    name: "Dashboard",
    Icon: LayoutDashboard,
    allowed: ["employee", "thirdparty"],
  },
  {
    route: "/app/bids",
    name: "My Bids",
    Icon: Gift,
    allowed: ["employee", "thirdparty"],
  },
  {
    route: "/app/profile",
    name: "Profile",
    Icon: User,
    allowed: ["employee", "thirdparty"],
  },
];
